const baseURL = 'http://turnos2.grupoinformaticofc.com/';

export default baseURL;
